import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const AutomationLogResultStatusKeys = new Set(['automationLogs.result'])

export const isAutomationLogResultStatusWidget = <T extends IFilterValue, C>(
  filterItem: FilterItem<T, C>
) => AutomationLogResultStatusKeys.has(filterItem.key)
